
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 10080 5040"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M0-360l69.421 215.845 212.038-80.301L155.99-35.603l194.985 115.71-225.881 19.651 31.105 224.59L0 160l-156.198 164.349 31.105-224.59-225.881-19.651 194.986-115.711-125.471-188.853 212.038 80.301z"}}),_c('path',{attrs:{"id":"d","d":"M0-210L54.86-75.508l144.862 10.614L88.765 28.842l34.67 141.052L0 93.334l-123.435 76.56 34.67-141.052-110.957-93.736L-54.86-75.508z"}}),_c('clipPath',{attrs:{"id":"b"}},[_c('path',{attrs:{"d":"M0 0v1.5h7V3H6zm6 0H3v3.5H0V3z"}})]),_c('use',{attrs:{"id":"c","xlink:href":"#a","transform":"scale(2.1)"}})]),_c('path',{attrs:{"fill":"#00008b","d":"M0 0h10080v5040H0z"}}),_c('path',{attrs:{"d":"M0 0l5040 2520m0-2520L0 2520","stroke":"#fff","stroke-width":"504"}}),_c('path',{attrs:{"d":"M0 0l6 3m0-3L0 3","stroke":"red","stroke-width":".4","clip-path":"url(#b)","transform":"scale(840)"}}),_c('path',{attrs:{"d":"M2520 0v2940M0 1260h5880","stroke":"#fff","stroke-width":"840"}}),_c('path',{attrs:{"d":"M2520 0v2940M0 1260h5880","stroke":"red","stroke-width":"504"}}),_c('path',{attrs:{"d":"M0 2520h5040V0h1680v3360H0z","fill":"#00008b"}}),_c('g',{attrs:{"fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#c","x":"2520","y":"3780"}}),_c('use',{attrs:{"xlink:href":"#a","x":"7560","y":"4200"}}),_c('use',{attrs:{"xlink:href":"#a","x":"6300","y":"2205"}}),_c('use',{attrs:{"xlink:href":"#a","x":"7560","y":"840"}}),_c('use',{attrs:{"xlink:href":"#a","x":"8680","y":"1869"}}),_c('use',{attrs:{"xlink:href":"#d","x":"8064","y":"2730"}})])])
          )
        }
      }
    